import { Path } from '../../models'

import { isSamePath } from './isSamePath'

export const isBookingPath = isSamePath(Path.Booking)
